<template>
    <div class="iframe-container">
      <iframe
        :src="iframeSrcWithParams"
        width="100%"
        height="100%"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </template>
  
  <script>
  export default {
    name: "IframePage",
    data() {
      return {
        baseUrl: "", // 基础URL，根据host判断后设置
        queryParams: {} // 存储路由参数
      };
    },
    computed: {
      iframeSrcWithParams() {
        // 将query参数拼接到URL
        const params = new URLSearchParams();
        for (const key in this.queryParams) {
          params.append(key, this.queryParams[key]);
        }
        return this.baseUrl + (params.toString() ? `?${params.toString()}` : '');
      }
    },
    created() {
      // 判断host并设置基础URL
      this.baseUrl = window.location.host.includes('bianque-man-') 
        ? 'https://jdh-vercel-yf.jd.com/lta4255fa3/index' 
        : 'https://jdh-vercel.jd.com/lta4255fa3/index';
      

      // 获取当前路由的所有参数
      this.queryParams = this.$route.query;
      
      // 打印调试信息（可选）
      console.log('Current host:', window.location.host);
      console.log('Using baseUrl:', this.baseUrl);
      console.log('Route query params:', this.queryParams);
      console.log('Final iframe src:', this.iframeSrcWithParams);
    }
  };
  </script>
  
  <style scoped>
  .iframe-container {
    height: 85vh;
    width: 100%;
  }
  
  iframe {
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  </style>
  